exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select_options[data-v-321a117c]{margin-right:5px;font-size:15px;background:#f2f2f2;height:140px;width:95%}.cart__item-info-line label[data-v-321a117c]{font-size:15px}", ""]);

// exports
